import type { FC } from 'react';
import React from 'react';

import type { TTableCell } from './models';

export const TableCell: FC<TTableCell> = ({ children, colspan, styles }) => {
    return (
        <td className={styles.td} colSpan={colspan}>
            {children}
        </td>
    );
};
